// 应用配置
export const config = {
  // 是否启用公共页面（预约、查询等）
  enablePublicPages: import.meta.env.VITE_ENABLE_PUBLIC_PAGES !== 'false',
  
  // API 基础地址
  apiUrl: import.meta.env.VITE_API_URL || '/api',
}

// 导出便捷判断
export const isPublicPagesEnabled = () => config.enablePublicPages
